import { useState } from 'preact/hooks';
import { performLogin } from '@/store/auth';
import css from './AuthScreen.module.css';

export function LoginForm({ onShowRegister, onShowForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await performLogin(email, password);
    } catch (err) {
      setError(err.message || 'Ошибка входа');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form class={css.form} onSubmit={handleSubmit} noValidate>
      <h2 class={css.title}>Вход в личный кабинет</h2>
      <div class={css.field}>
        <label htmlFor="login-email">E-mail</label>
        <input
          id="login-email"
          type="email"
          required
          autoComplete="username"
          placeholder="email@company.ru"
          value={email}
          onInput={(e) => setEmail(e.target.value)}
        />
      </div>
      <div class={css.field}>
        <label htmlFor="login-password">Пароль</label>
        <input
          id="login-password"
          type="password"
          required
          autoComplete="current-password"
          placeholder="Введите пароль"
          value={password}
          onInput={(e) => setPassword(e.target.value)}
        />
      </div>
      {error && (
        <div class={css.error} role="alert">
          {error}
        </div>
      )}
      <button class={css.submit} type="submit" disabled={submitting}>
        {submitting ? 'Входим…' : 'Войти'}
      </button>
      <div class={css.links}>
        {/* Регистрация выключена в проде — клиентов заводит 1С. Оставлено для dev. */}
        {onShowRegister && false && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onShowRegister();
            }}
          >
            Регистрация
          </a>
        )}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onShowForgot();
          }}
        >
          Забыли пароль?
        </a>
      </div>
    </form>
  );
}
